"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = onClick;
const On_1 = require("../../Framework/Decorators/On");
/**
 * @param role The data role to match on. Different matching-patterns can be prefixed. Supported: ~, ^, &, *, |
 *             See SelectorHelper.createDataRoleSelector
 * @param options
 * @see SelectorHelper.createDataRoleSelector
 */
function onClick(role, options) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, On_1.default)('click', role, options);
}
//# sourceMappingURL=OnClick.js.map